import { initializeApp } from 'firebase/app';
import { getStorage } from 'firebase/storage';
import { getFirestore } from 'firebase/firestore';

const firebase = initializeApp({
  apiKey: "AIzaSyAfGsbGXAFAPsRJMfSTU7REWF-eBpjqJWk",
  authDomain: "twoj-projekt.firebaseapp.com",
  projectId: "twoj-projekt",
  storageBucket: "twoj-projekt.appspot.com",
  messagingSenderId: "205829340390",
  appId: "1:205829340390:web:43db49924c210793288f27"
});

export { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';

export * from 'firebase/firestore';

export default firebase;
export const db = getFirestore(firebase);
export const storage = getStorage(firebase);

export const FUNCTIONS_URL = 'https://europe-central2-twoj-projekt.cloudfunctions.net/api';
// export const FUNCTIONS_URL = 'http://127.0.0.1:5001/twoj-projekt/europe-central2/api';